// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avatar-container {
    display:flex;
    flex-direction: row;
    align-items: center;
    width: 50%;
    overflow-x: auto;
    gap: 20px;
    padding: 20px;
    border-radius: 10px;
    scrollbar-width: thin;
    scrollbar-color: #888 #f5f5f5;
}


.avatar-container::-webkit-scrollbar {
    height: 8px;
}

.avatar-container::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 4px;
}

.avatar-image {
    width: 12vmin;
    height: 12vmin;
    object-fit: cover;
    border-radius: 50%;
    border: 4px solid #8b8b8b;
    transition: transform 0.3s ease;
    background-size: cover;
    background-position: center;
}
.avatar-button {
    min-width: 14vmin;
    min-height: 14vmin;
    object-fit: cover;
    border-radius: 50%;
    border: 4px solid #8b8b8b;
    transition: transform 0.3s ease;
    background-size: cover;
    background-position: center;
    margin-left: 40%;
}
.avatar-button:hover {
    transform: scale(1.1);
    border: 4px solid #28a745;
}

.avatar-image:hover {
        transform: scale(1.3);
        border: 4px solid #28a745;
    }


.avatar-image:nth-child(odd):hover,
.avatar-image:nth-child(even):hover {
    transform: scale(1.1);
}

.linked_avatar {
    margin-top: 10%;
    margin-left: -5%;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    text-decoration: underline;
    outline: none;
    position: relative;
    transition: text-shadow 0.4s ease-in-out;
    color: #ffffff;
  }
  
.linked_avatar:hover {
    text-shadow: 0px 0px 5px rgba(255, 255, 255, 0.8);
    animation: glowEffect 0.4s forwards;
  }

`, "",{"version":3,"sources":["webpack://./src/components/profile/avatar/avatar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,6BAA6B;AACjC;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,+BAA+B;IAC/B,sBAAsB;IACtB,2BAA2B;AAC/B;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,+BAA+B;IAC/B,sBAAsB;IACtB,2BAA2B;IAC3B,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;QACQ,qBAAqB;QACrB,yBAAyB;IAC7B;;;AAGJ;;IAEI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,0BAA0B;IAC1B,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,cAAc;EAChB;;AAEF;IACI,iDAAiD;IACjD,mCAAmC;EACrC","sourcesContent":[".avatar-container {\n    display:flex;\n    flex-direction: row;\n    align-items: center;\n    width: 50%;\n    overflow-x: auto;\n    gap: 20px;\n    padding: 20px;\n    border-radius: 10px;\n    scrollbar-width: thin;\n    scrollbar-color: #888 #f5f5f5;\n}\n\n\n.avatar-container::-webkit-scrollbar {\n    height: 8px;\n}\n\n.avatar-container::-webkit-scrollbar-thumb {\n    background-color: #888;\n    border-radius: 4px;\n}\n\n.avatar-image {\n    width: 12vmin;\n    height: 12vmin;\n    object-fit: cover;\n    border-radius: 50%;\n    border: 4px solid #8b8b8b;\n    transition: transform 0.3s ease;\n    background-size: cover;\n    background-position: center;\n}\n.avatar-button {\n    min-width: 14vmin;\n    min-height: 14vmin;\n    object-fit: cover;\n    border-radius: 50%;\n    border: 4px solid #8b8b8b;\n    transition: transform 0.3s ease;\n    background-size: cover;\n    background-position: center;\n    margin-left: 40%;\n}\n.avatar-button:hover {\n    transform: scale(1.1);\n    border: 4px solid #28a745;\n}\n\n.avatar-image:hover {\n        transform: scale(1.3);\n        border: 4px solid #28a745;\n    }\n\n\n.avatar-image:nth-child(odd):hover,\n.avatar-image:nth-child(even):hover {\n    transform: scale(1.1);\n}\n\n.linked_avatar {\n    margin-top: 10%;\n    margin-left: -5%;\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 16px;\n    text-decoration: underline;\n    outline: none;\n    position: relative;\n    transition: text-shadow 0.4s ease-in-out;\n    color: #ffffff;\n  }\n  \n.linked_avatar:hover {\n    text-shadow: 0px 0px 5px rgba(255, 255, 255, 0.8);\n    animation: glowEffect 0.4s forwards;\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
